var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMti3Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6785 8.83975C17.6785 13.2534 12.7823 17.85 11.1381 19.2696C10.9849 19.3848 10.7985 19.447 10.6068 19.447C10.4152 19.447 10.2287 19.3848 10.0756 19.2696C8.43141 17.85 3.53516 13.2534 3.53516 8.83975C3.53516 6.96422 4.28021 5.16551 5.6064 3.83931C6.9326 2.51312 8.73131 1.76807 10.6068 1.76807C12.4824 1.76807 14.2811 2.51312 15.6073 3.83931C16.9335 5.16551 17.6785 6.96422 17.6785 8.83975Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 1.76792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6079 11.4915C12.0725 11.4915 13.2598 10.3042 13.2598 8.83962C13.2598 7.37503 12.0725 6.18774 10.6079 6.18774C9.14334 6.18774 7.95605 7.37503 7.95605 8.83962C7.95605 10.3042 9.14334 11.4915 10.6079 11.4915Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 1.76792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.215,
    height: 21.215,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMti3Icon);
export default __webpack_public_path__ + "static/media/mti3Icon.da9fd5ae62afcf1c66a2adca33b42748.svg";
export { ForwardRef as ReactComponent };